import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import QrScanner from "qr-scanner";
import {
  studentWithConnect,
  studentWithConnectClear,
  showModal,
  hideModal,
  setHelpList,
} from "../../common/actions/userAccount";
import { Slide, toast } from "react-toastify";

class UploadQRCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedImage: props.scannedImageData || null,
      scannedImageData: props.scannedImageData || null,
      showImagePreview: !!props.scannedImageData,
      scanDone: false,
      scanResult: null,
      localError: "",
    };
  }
  toastOptions = {
    autoClose: 2000,
    transition: Slide,
    hideProgressBar: true,
    icon: false,
  };

  handleUploadQR = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      this.setState({
        uploadedImage: e.target.result,
        scannedImageData: e.target.result,
        showImagePreview: true,
        scanDone: false,
        scanResult: null,
        localError: "",
      });
    };

    reader.onerror = () => {
      this.setState({ localError: this.props.t("upload-error") });
    };

    reader.readAsDataURL(file);
  };

  scanUploadedQR = async () => {
    try {
      const { scannedImageData } = this.state;
      const scannedData = await QrScanner.scanImage(scannedImageData, {
        returnDetailedScanResult: true,
      });

      if (scannedData?.data) {
        this.setState(
          {
            scanResult: scannedData.data,
            scanDone: true,
          },
          this.processScan
        );
      } else {
        toast.error(this.props.t("ScanSrc-NoQRCodeFound"), this.toastOptions);
      }
    } catch {
      toast.error(this.props.t("ScanSrc-NoQRCodeFound"), this.toastOptions);
    }
  };
  
  processScan = () => {
    const { scanResult } = this.state;
    this.props.doStudentWithConnect({ Code: scanResult });
  };

  componentDidUpdate(prevProps) {
    const {
      error,
      studentConnectResponse,
      doStudentWithConnectClear,
      doCallbackRefresh,
      scannedImageData,
    } = this.props;

    if (
      scannedImageData &&
      scannedImageData !== prevProps.scannedImageData
    ) {
      this.setState({
        uploadedImage: scannedImageData,
        scannedImageData,
        showImagePreview: true,
      });
    }

    if (error || this.state.localError) {
      toast.error(this.state.localError || error.Message, this.toastOptions);
      this.closeModal();
      doCallbackRefresh?.();
      doStudentWithConnectClear();
    }

    if (studentConnectResponse) {
      toast.success(studentConnectResponse.Message, this.toastOptions);
      this.closeModal();
      doCallbackRefresh?.();
      doStudentWithConnectClear();
    }
  }

  closeModal = () => {
    this.setState({
      uploadedImage: null,
      scannedImageData: null,
      showImagePreview: false,
    });
    const { setCameraOpen, doHideModal, onCloseModal } = this.props;
    if (setCameraOpen) setCameraOpen(false);
    if (onCloseModal) onCloseModal();
    doHideModal();
  };

  render() {
    const { uploadedImage, showImagePreview } = this.state || {};
  
    return (
      <>
        {showImagePreview && uploadedImage && (
          <div className="qr-preview-modal">
          <div className="preview-box">
            <button className="close-btnQR" onClick={this.closeModal}>&times;</button>
            <h5>{this.props.t("sel-img")}</h5>
            <img src={uploadedImage} alt="QR Code Preview" className="qr-preview-image" />
            <div className="preview-actions">
              <button className="scan-btn" onClick={this.scanUploadedQR}>
                {this.props.t("scan")}
              </button>
              <label className="upload-btn">
                {this.props.t("upload-qr")}
                <input
                  type="file"
                  accept="image/*"
                  onChange={this.handleUploadQR}
                  className="upload-label-input"
                />
              </label>
            </div>
          </div>
        </div>        
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    error: state.userAccount.error,
    studentConnectResponse: state.userAccount.studentConnectResponse,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    doStudentWithConnect: (data) => dispatch(studentWithConnect(data)),
    doStudentWithConnectClear: () => dispatch(studentWithConnectClear()),
    doHideModal: () => dispatch(hideModal()),
    doShowModal: (data) => dispatch(showModal(data)),
    dosetHelpList: (data) => dispatch(setHelpList(data)),
  };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(UploadQRCode));
